module.exports = __webpack_public_path__ + "img/atm.a1463e21.svg";